import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import config from "config";

async function getUser() {
  const { data } = await axios.get("auth/agent/me");
  return data;
}

export default function useUser() {
  return useQuery<User>([config.userKey], getUser);
}

export const useAuth = useUser as () => { data: User };
